import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  routes: [
    // 首页
    {
      path: "/",
      component: () => import("@/pages/index")
    },

    // 登录
    {
      path: "/",
    },
    {
      path: "/login",
      component: () => import("@/pages/auth/Login")
    },

    // 电源模块
    {
      path: "/mod/power",
      component: () => import("@/pages/mods/power")
    },
    // 灯光模块
    {
      path: "/mod/light",
      component: () => import("@/pages/mods/light")
    },
    // 紫外消杀灯
    {
      path: "/mod/ultraviolet_sterilizer",
      component: () => import("@/pages/mods/ultraviolet_sterilizer")
    },
    // 空气消杀灯
    {
      path: "/mod/air_sterilizer",
      component: () => import("@/pages/mods/air_sterilizer")
    },
    // 语音播报
    {
      path: "/mod/voice_announcer",
      component: () => import("@/pages/mods/voice_announcer")
    },
    // 照明消杀
    {
      path: "/mod/light_sterilizer",
      component: () => import("@/pages/mods/light_sterilizer")
    },
    // 空调模块
    {
      path: "/mod/air_conditioner",
      component: () => import("@/pages/mods/air_conditioner")
    },
    // 新风机模块
    {
      path: "/mod/fresh_air_machine",
      component: () => import("@/pages/mods/fresh_air_machine")
    },
    // 风扇模块
    {
      path: "/mod/fan",
      component: () => import("@/pages/mods/fan")
    },
    // 调速风扇模块
    {
      path: "/mod/speed_changeable_fan",
      component: () => import("@/pages/mods/speed_changeable_fan")
    },
    // 一体机模块
    {
      path: "/mod/ops",
      component: () => import("@/pages/mods/ops")
    },
    // 投影机模块
    {
      path: "/mod/projector",
      component: () => import("@/pages/mods/projector")
    },
    // 扩声模块
    {
      path: "/mod/sound_reinforcement",
      component: () => import("@/pages/mods/sound_reinforcement")
    },
    // 温湿度模块
    {
      path: "/mod/temperature",
      component: () => import("@/pages/mods/temperature")
    },
    // 电量统计模块
    {
      path: "/mod/electric",
      component: () => import("@/pages/mods/electric")
    },
    // 墙插
    {
      path: "/mod/wall_plug",
      component: () => import("@/pages/mods/wall_plug")
    },
    // 窗帘模块
    {
      path: "/mod/window_curtain",
      component: () => import("@/pages/mods/window_curtain")
    },
    // 幕布模块
    {
      path: "/mod/curtain",
      component: () => import("@/pages/mods/curtain")
    },
    // 门禁模块
    {
      path: "/mod/door",
      component: () => import("@/pages/mods/door")
    },
    // 门磁模块
    {
      path: "/mod/door_sensor",
      component: () => import("@/pages/mods/door_sensor")
    },
    // 人体存在模块
    {
      path: "/mod/hb01",
      component: () => import("@/pages/mods/hb01")
    },
    // 空气质量模块
    {
      path: "/mod/fourinone_sensor",
      component: () => import("@/pages/mods/fourinone_sensor")
    },
    // 可调灯模块
    {
      path: "/mod/adjustable_light",
      component: () => import("@/pages/mods/adjustable_light")
    },
    // 光照传感模块
    {
      path: "/mod/light_sensor",
      component: () => import("@/pages/mods/light_sensor")
    },
  ]
});

function is_login() {
  let token = localStorage.getItem("token");
  let username = localStorage.getItem("username");
  if (token && username) {
    return true;
  } else {
    return false;
  }
}

router.beforeEach((to, from, next) => {
  // 进入其他界面如果没有token则退回到登录界面
  if (to.path !== "/login") {
    if (!is_login()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    console.log(1)
    next(); // 确保一定要调用 next()
    console.log(2)
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js